<common-confirm></common-confirm>


<h1 class="container-heading">Warehouses List</h1>

<mat-card>
    <mat-card-content>

    </mat-card-content>
</mat-card>